import { Box, Grid, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router";
import { userLogout } from "../../../../api/auth";
import { DefaultButton } from "../../../../components/form";
import { ROUTE_PATHS } from "../../../../routes/paths";
import { useAppDispatch, useAppSelector } from "../../../../store";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Logo from "../../../../components/Logo";
import FlexBox from "../../../../components/layouts/Flexbox";
import { APP_COLORS } from "../../../../enums";
import AuthBGImage from "../../../../HOC/AuthBGImage";

function SignupComplete() {
  const user = useAppSelector((state) => state.auth.user);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      dispatch(userLogout());
    };
  }, []);

  if (!user.id && !user.isLoggedIn)
    return <Navigate to={ROUTE_PATHS.AUTH.LOGIN} replace />;

  return (
    <Box bgcolor={APP_COLORS.greyLight}>
      <Grid container width={"100%"} height={"100vh"} justifyContent={"space-between"} bgcolor={APP_COLORS.white}>
        <Grid item xs={12} md={7} component={Stack} height={"100vh"} direction={"column"} justifyContent={"center"} alignItems={"center"} width={"100%"} flex={1}>
          <FlexBox sx={{ marginTop: 10 }}>
            <Logo />
          </FlexBox>

          <Stack justifyContent={"center"} height={"100%"} width={"100%"} gap={5} maxWidth={643}>
            <Typography variant="large-bold" textAlign={"center"}>
              Thank you for submitting your information. We would like to inform
              you that your profile has been received and is currently under
              review by Execweb. We will notify you via email as soon as your
              profile has been approved.
            </Typography>
            <DefaultButton
              color="secondary"
              onClick={async () => {
                await dispatch(userLogout());
                return navigate(ROUTE_PATHS.AUTH.LOGIN);
              }}
              startIcon={<ArrowBackIcon />}
            >
              Back to Login
            </DefaultButton>
          </Stack>
        </Grid>
        <Grid item xs={12} md={5} component={FlexBox} height={"100vh"}>
          <AuthBGImage />
        </Grid>
      </Grid>
    </Box >
  );
}

export default SignupComplete;
